'use client';

import { Button } from '~/components/primitives';
import { useI18n } from '~/features/i18n';

export namespace FileDownloadSDK {
    export async function downloadURL(
        url: string | URL,
        // prettier-ignore
        fileName: string = (
            url instanceof URL
                ? url
                : new URL(url)
        ).pathname.split('/').pop() ?? 'download',
    ) {
        return fetch(url, {
            method: 'GET',
            referrerPolicy: 'no-referrer',
            mode: 'no-cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
        })
            .then(async res => {
                if (res.ok) return res.blob();
                throw new Error(`Response ${res.status} "${res.statusText}": ${await res.text()}`);
            })
            .then(blob => FileDownloadSDK.downloadBlob(blob, fileName))
            .catch((error: Error) => {
                throw new Error(
                    `Failed to download file "${url}". Error "${error.name}": ${error.message}`,
                    {
                        cause: error,
                    },
                );
            });
    }

    export function downloadBlob(blob: Blob, fileName: string) {
        const aElement = document.createElement('a');
        aElement.setAttribute('download', fileName);
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
    }
}

export const DownloadButton: React.FC<
    Button.Props & {
        file: {
            url: string | URL;
            name: string;
        };
    }
> = props => {
    const i18n = useI18n();

    return (
        <Button
            {...props}
            iconBefore="download"
            onClick={async e => {
                await Promise.all([
                    props.onClick?.(e),
                    FileDownloadSDK.downloadURL(props.file.url, props.file.name),
                ]);
            }}
        >
            {props.children ?? i18n._('Download')}
        </Button>
    );
};
